import { useExpirableFileOpenerProps } from "./fetch";
import { ExpirableFileOpenerUi } from "./ui";

export type { ExpirableFileOpenerProps } from "./model";

export const ExpirableFileOpener = (params: {
  url: string;
  filename: string;
}) => {
  const props = useExpirableFileOpenerProps(params.url, params.filename);
  return <ExpirableFileOpenerUi {...props} />;
};
